/** Every module that can appear in x-modules. Add new modules here and give them a name below. */
export type ModuleId =
  | '3.1'
  | '3.2'
  | '3.3'
  | '3.4'
  | '3.5'
  | '3.6'
  | '4.1'
  | '4.2'
  | '4.3'
  | '4.4'
  | '4.5'
  | '4.6'
  | '4.7'
  | '5.1'
  | '5.2'
  | '5.3'
  | '5.4'
  | '5.5'
  | '6.1'
  | '6.2'
  | '6.3'
  | '6.4'
  | '7.1'
  | '8.1'
  | '8.2'
  | '9.1'
  | '10.1'
  | '11.1'
  | '12.1'
  | '13.1'
  | '14.1'
  | '15.1'
  | '15.2'
  | '15.3'
  | '15.4'
  | '15.5'
  | '15.6'
  | '15.7'
  | '15.8'
  | '15.9'
  | '15.10'
  | '15.11'
  | '15.12'
  | '15.13'
  | '16.2'
  | '16.3'
  | '16.4'
  | '16.5'
  | '16.6'
  | 'Allocation'
  | 'Intensities';

/**
 * Human readable names for each module referenced by x-modules in the 4.x openapi specs. Modules missing from
 * here are shown by their raw value, so add new modules as they appear.
 */
const MODULE_NAMES: Record<ModuleId, string> = {
  '3.1': '3.1 - Enteric Methane (Beef Feedlot)',
  '3.2': '3.2 - Enteric Methane (Beef)',
  '3.3': '3.3 - Enteric Methane (Dairy)',
  '3.4': '3.4 - Enteric Methane (Sheep)',
  '3.5': '3.5 - Enteric Methane (Pigs)',
  '3.6': '3.6 - Enteric Methane (Other Livestock)',
  '4.1': '4.1 - Manure Management (Beef Feedlot)',
  '4.2': '4.2 - Manure Management (Beef)',
  '4.3': '4.3 - Manure Management (Dairy)',
  '4.4': '4.4 - Manure Management (Sheep)',
  '4.5': '4.5 - Manure Management (Pigs)',
  '4.6': '4.6 - Manure Management (Poultry)',
  '4.7': '4.7 - Manure Management (Other Livestock)',
  '5.1': '5.1 - Inorganic and Urea Fertiliser',
  '5.2': '5.2 - Organic Fertiliser',
  '5.3': '5.3 - Lime',
  '5.4': '5.4 - Atmospheric Deposition from Fertiliser',
  '5.5': '5.5 - Leaching and Runoff from Fertiliser',
  '6.1': '6.1 - Return of Crop Residues to Soils',
  '6.2': '6.2 - Return of Pasture Residues to Soils',
  '6.3': '6.3 - Leaching and Runoff from Residues',
  '6.4': '6.4 - Field Burning of Crop Residues',
  '7.1': '7.1 - Rice Cultivation',
  '8.1': '8.1 - Transport Fuel',
  '8.2': '8.2 - Stationary Fuel',
  '9.1': '9.1 - Refrigerant use',
  '10.1': '10.1 - Solid Waste Treatment',
  '11.1': '11.1 - Wastewater Treatment',
  '12.1': '12.1 - Purchased CO2',
  '13.1': '13.1 - N2O Emissions from Aquaculture',
  '14.1': '14.1 - Purchased Electricity',
  '15.1': '15.1 - Purchased Livestock',
  '15.2': '15.2 - Purchased Feed',
  '15.3': '15.3 - Purchased Mineral Supplements',
  '15.4': '15.4 - Purchased Fertiliser',
  '15.5': '15.5 - Purchased Agrichemicals',
  '15.6': '15.6 - Purchased Soil Ameliorants',
  '15.7': '15.7 - Purchased Services/Contractors',
  '15.8': '15.8 - Purchased Packaging',
  '15.9': '15.9 - Other Purchased Goods and Services',
  '15.10': '15.10 - Upstream Emissions from Fuel',
  '15.11': '15.11 - Upstream Emissions of Purchased Electricity',
  '15.12': '15.12 - Management of Waste',
  '15.13': '15.13 - Upstream Freight',
  '16.2': '16.2 - LULUCF',
  '16.3': '16.3 - LULUCF - Soil Organic Carbon Losses',
  '16.4': '16.4 - LULUCF - Leaching and Run-off Emissions',
  '16.5': '16.5 - LULUCF - Savanna Fire Management',
  '16.6': '16.6 - LULUCF - Perennial Woody Crops',
  Allocation: 'Allocation of Emissions',
  Intensities: 'Emissions Intensities',
};

/** Whether a value, e.g. from x-modules in a spec, is a known module */
export const isModuleId = (value: unknown): value is ModuleId =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(MODULE_NAMES, value);

/** Display label for a module, e.g. "8.1 - Transport Fuel" */
export const getModuleLabel = (module: ModuleId) => MODULE_NAMES[module];
